module.exports = __webpack_public_path__ + "static/media/paint-format.3476dff4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/paint-format.svg
// module id = 3265
// module chunks = 7